<template>
  <div>
    <b-card style="height: 82vh; overflow-y: hidden;">
      <b-row no-gutters style="height: 100%">
        <!--<b-col cols="12" md="12">
          <span v-for="(label, index) in labels" :key="index" class="badge me-1 label-gmail"
            @click="labelSeleccionado = label.id" :class="{ 'label-selected': labelSeleccionado === label.id }" :style="{
              backgroundColor:
                label.color && label.color.backgroundColor
                  ? label.color.backgroundColor
                  : '#6c757d',
              color:
                label.color && label.color.textColor
                  ? label.color.textColor
                  : '#fff',
            }">
            {{ label.name }} ({{ label.cantidad }}-{{ label.total }})
          </span>
        </b-col>-->

        <b-col cols="12">
          <hr />
        </b-col>

        <b-col cols="12" md="3" class="border-right email-list p-1" style="height: 95%; overflow-y: auto">
          <div v-if="labelSeleccionado" style="margin-bottom: 2px; margin-top: -10px">
            <span class="badge-custom" :style="{
              backgroundColor:
                (labels.find((l) => l.id === labelSeleccionado) &&
                  labels.find((l) => l.id === labelSeleccionado).color &&
                  labels.find((l) => l.id === labelSeleccionado).color
                    .backgroundColor) ||
                '#6c757d',
              color:
                (labels.find((l) => l.id === labelSeleccionado) &&
                  labels.find((l) => l.id === labelSeleccionado).color &&
                  labels.find((l) => l.id === labelSeleccionado).color
                    .textColor) ||
                '#fff',
            }">
              <i class="fa-regular fa-bookmark"></i>
              {{
                labels.find((l) => l.id === labelSeleccionado) &&
                labels.find((l) => l.id === labelSeleccionado).name
              }}
              ({{
                labels.find((l) => l.id === labelSeleccionado) &&
                labels.find((l) => l.id === labelSeleccionado).cantidad
              }}-{{
                labels.find((l) => l.id === labelSeleccionado) &&
                labels.find((l) => l.id === labelSeleccionado).total
              }})
            </span>
          </div>
          <div style="
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 3px;
            ">
            <b-button variant="success" size="sm" @click="abrirModalNuevoEmail" title="Nuevo mensaje" style="white-space: nowrap;">
              <i class="fa-solid fa-plus"></i> Nuevo
            </b-button>
            <b-form-input v-model="searchQuery" type="text" placeholder="Buscar correo..." style="flex: 1" />
            <b-button v-if="searchQuery != ''" @click="buscarGmail" style="padding: 10px"
              class="button-search-google"><i class="fa-solid fa-magnifying-glass-plus"></i><i
                class="fa-brands fa-google"></i></b-button>
          </div>

          <div @click="readFilter = !readFilter"
            class="cursor-pointer badge label-gmail d-inline-flex align-items-center justify-content-center" :style="{
              backgroundColor: readFilter ? '#007bff' : '#6c757d',
              color: '#fff',
              width: '30px',
              height: '30px',
              borderRadius: '50%',
            }">
            <i v-if="readFilter" class="fa-regular fa-envelope"></i>
            <i v-else class="fa-regular fa-envelope-open"></i>
          </div>

          <b-list-group>
            <b-list-group-item v-for="(email, index) in filteredEmails" :key="index" class="group-item-email"
              @click="openEmail(email)" :class="{
                'active-email': selectedEmail && selectedEmail.id === email.id,
                'unread-email': email.leido === 0,
                'viene-busqueda': email.vieneDeBusqueda,
              }">
              <div class="email-header-row">
                <div class="email-sender-info">
                  <i v-if="email.chatgpt && email.chatgpt.tono == 'positivo'"
                    class="fa-regular fa-face-grin-beam face-tono face-positivo"></i>
                  <i v-if="email.chatgpt && email.chatgpt.tono == 'negativo'"
                    class="fa-regular fa-face-angry face-tono face-negativo"></i>
                  <i v-if="email.chatgpt && email.chatgpt.tono == 'neutral'"
                    class="fa-regular fa-face-meh face-tono face-neutro"></i>
                  <strong class="email-sender-name">
                    {{ extractName(email.from) }}</strong>
                </div>

                <!-- Fecha y Labels arriba derecha -->
                <div class="email-date-labels">
                  <small class="email-date">{{ formatDate(email.data.internalDate) }}</small>
                  <span v-for="label in labels.filter(
                    (l) =>
                      email.data.labelIds.includes(l.id) && l.id !== 'INBOX'
                  )" :key="label.id" class="badge email-label-badge" :style="getLabelColor(label.id)">
                    {{ label.name }}
                  </span>
                </div>
              </div>

              <div class="text-muted mt-0 email-preview">
                {{
                  email.body
                    ? truncateText(stripHtml(email.subject), 200)
                    : "(sin contenido)"
                }}
              </div>
              <!--<div class="text-muted email-preview" style="margin-top: 2px" v-if="email.chatgpt.resumen">
              <b>Resumen:</b> {{ email.chatgpt.resumen}}
            </div>-->
            </b-list-group-item>
          </b-list-group>

          <div v-if="!filteredEmails.length" class="text-center mt-3 text-muted">
            <h5 v-if="!cargandoCorreos">No se encontraron correos</h5>
            <div v-else class="d-flex justify-content-center align-items-center" style="height: 100px">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="9" class="email-detail p-1" style="height: 95%; overflow-y: auto">
          <transition name="fade">
            <div v-if="selectedEmail">
              <!--<p @click="marcarLeidoGmail">Marcar como leido</p>-->

              <div style="
                  margin-bottom: 10px;
                  border: 1px solid lightgray;
                  border-radius: 10px;
                  padding: 5px;
                ">
                <div v-if="!waitingChatGpt">
                  <span @click="askChatGpt()" class="btn-askgpt"><i class="fa-brands fa-openai"></i> Analizar con
                    ChloeGPT</span><br />
                  <div v-if="
                    selectedEmail.chatgpt.resumen != undefined &&
                    selectedEmail.chatgpt.resumen.length > 0
                  ">
                    <span><b>Resumen:</b> {{ selectedEmail.chatgpt.resumen }}</span><br />
                    <!--<span><b>Tipo:</b> {{ selectedEmail.chatgpt.tipo }}</span><br>-->
                    <span><b>Accion sugerida:</b>
                      {{ selectedEmail.chatgpt.accion_sugerida }}</span><br />
                    <!--<span><b>Label:</b>  {{ selectedEmail.chatgpt.label }}</span><br>-->
                  </div>

                  <p v-if="
                    selectedEmail.chatgpt.accion_sugerida != 'ignorar' &&
                    selectedEmail.chatgpt.respuesta_aconsejada != undefined
                  ">
                    <b>Respuesta Aconsejada:</b>
                    <br />
                    <span v-if="!waitingNewAsk" v-html="formattedRespuesta"></span>
                  </p>
                  <div v-if="waitingNewAsk" class="d-flex justify-content-center align-items-center"
                    style="height: 100px">
                    <i class="fa-brands fa-openai fa-spin-custom text-primary" style="font-size: 2rem"></i>
                  </div>

                  <b-input-group class="groupNewAsk" v-if="
                    !waitingNewAsk &&
                    selectedEmail.chatgpt.resumen !== undefined
                  " style="margin-bottom: 3px">
                    <!-- Icono OpenAI a la izquierda -->
                    <b-input-group-text style="border: none">
                      <i class="fa-brands fa-openai"></i>
                    </b-input-group-text>

                    <!-- Input -->
                    <b-form-input v-model="newAsk" type="search" placeholder="Nuevas órdenes sobre respuesta aconsejada"
                      @keyup.enter="enviarNuevaOrden" autocomplete="off" name="openai_order_input"
                      id="openai_order_inputid" />

                    <!--<b-form-textarea
                  v-model="newAsk"
                  placeholder="Nuevas órdenes sobre respuesta aconsejada"
                  @keyup.enter="enviarNuevaOrden"
                  autocomplete="off"
                  name="openai_order_input"
                  id="openai_order_inputid"
                  rows="3"       
                  max-rows="6"   
                />-->

                    <!-- Flecha/Enviar solo si hay texto -->
                    <b-input-group-append v-if="newAsk.trim() !== ''">
                      <b-button @click="enviarNuevaOrden" variant="primary"
                        style="height: 38px; box-shadow: none !important">
                        <i class="fa-solid fa-arrow-up"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center" style="height: 100px">
                  <i class="fa-brands fa-openai fa-spin-custom text-primary" style="font-size: 2rem"></i>
                </div>
              </div>

              <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 5px;
                ">
                <b-button @click="openModalEnviar(selectedEmail)">
                  <i class="fa-solid fa-reply"></i> Responder
                </b-button>

                <b-button @click="loadThread(selectedEmail)" :disabled="loadingThread" variant="outline-primary">
                  <i v-if="loadingThread" class="fa-solid fa-spinner fa-spin"></i>
                  <i v-else class="fa-solid fa-comments"></i>
                  {{ showThread ? 'Ocultar hilo' : 'Ver hilo completo' }}
                </b-button>

                <b-button @click="marcarComoLeido" v-if="selectedEmail.leido == 0">
                  <i class="fa-solid fa-envelope-open"></i> Marcar como leído
                </b-button>
                <b-button @click="marcarComoNoLeido" v-else variant="primary">
                  <i class="fa-solid fa-envelope"></i> Marcar como no leído
                </b-button>
              </div>

              <div class="d-flex align-items-center mb-0">
                <strong>Asunto:</strong>
                <h5 class="mb-0 flex-grow-1">
                  {{ selectedEmail.subject || "(Sin asunto)" }}
                </h5>
              </div>

              <p class="text-muted mb-0">
                <strong>De:</strong>
                {{ extractName(selectedEmail.from) }}
                &lt;{{ extractMail(selectedEmail.from) }}&gt;
              </p>
              <p class="text-muted mb-0">
                <strong>Fecha:</strong>
                {{ formatDate(selectedEmail.data.internalDate) }}
              </p>

              <div v-if="
                selectedEmail.attachments && selectedEmail.attachments.length
              " class="attachments-list mb-2">
                <strong>Adjuntos:</strong>
                <ul class="list-unstyled mb-0">
                  <li v-for="(att, index) in selectedEmail.attachments" :key="index" class="mb-1">
                    <!-- Si es imagen y ya la descargaste -->
                    <template v-if="att.mimeType.startsWith('image/') && att.url">
                      <img :src="att.url" @click="openImage(att)" style="
                          max-width: 100px;
                          cursor: pointer;
                          border: 1px solid #ccc;
                          border-radius: 4px;
                        " />
                    </template>

                    <!-- Enlace normal si no es imagen o no se ha descargado -->
                    <template v-else>
                      <a href="#" @click.prevent="descargarAdjunto(selectedEmail, att)">
                        {{ att.filename }}
                      </a>
                    </template>
                  </li>
                </ul>
              </div>

              <hr />

              <!-- Hilo de conversación (arriba del correo principal) -->
              <div v-if="showThread" class="thread-container mb-3">
                <div class="thread-header d-flex justify-content-between align-items-center mb-2">
                  <h5 class="mb-0"><i class="fa-solid fa-comments"></i> Hilo de conversación ({{ threadMessages.length }} mensajes)</h5>
                  <b-button size="sm" variant="outline-secondary" @click="showThread = false">
                    <i class="fa-solid fa-times"></i> Cerrar
                  </b-button>
                </div>

                <div v-if="loadingThread" class="d-flex justify-content-center align-items-center" style="height: 100px">
                  <div class="spinner-border text-primary" role="status"></div>
                </div>

                <div v-else class="thread-messages">
                  <div v-for="(msg, index) in threadMessages" :key="msg.id+index" class="thread-message mb-3" :class="{ 'current-message': msg.id === selectedEmail.idGmail }">
                    <div class="thread-message-header p-2" :style="{ backgroundColor: msg.id === selectedEmail.idGmail ? '#e3f2fd' : '#f8f9fa' }">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{ extractName(msg.from) }}</strong>
                          <small class="text-muted ml-2">{{ extractMail(msg.from) }}</small>
                        </div>
                        <small class="text-muted">{{ formatDate(msg.internalDate) }}</small>
                      </div>
                      <div class="text-muted mt-1">
                        <strong>Asunto:</strong> {{ msg.subject }}
                      </div>
                    </div>
                    <div class="thread-message-body">
                      <iframe class="thread-iframe" :srcdoc="msg.body"></iframe>
                    </div>
                  </div>
                </div>
              </div>

              <iframe v-if="selectedEmail" class="email-iframe" :srcdoc="htmlOplano(selectedEmail)"></iframe>

              <div style="text-align: center">
                <b-button @click="openModalEnviar(selectedEmail)"><i class="fa-solid fa-reply"></i> Responder</b-button>
              </div>
            </div>

            <div v-else class="text-center text-muted mt-5">
              <feather-icon icon="MailIcon" size="40" class="mb-1" />
              <h5>Selecciona un correo para ver su contenido</h5>
            </div>
          </transition>
        </b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-email" title="Responder" centered size="xl" hide-footer class="modal-max-height">
      <div>
        <b-row>
          <b-col cols="3">
            <div>
              <h3>Listado Plantillas</h3>
              <b-row>
                <b-col md="12">
                  <b-form-input id="unidades" type="text" placeholder="Buscar Plantilla" v-model="buscarPlantilla" />
                </b-col>
              </b-row>
              <b-button style="margin-top: 5px; margin-bottom: 5px" v-if="
                selectedEmail &&
                selectedEmail.chatgpt &&
                selectedEmail.chatgpt.respuesta_aconsejada
              " @click="usarRespuestaChloe">Usar respuesta Chloe</b-button>
              <br v-else />
              <b-row>
                <b-col md="12">
                  <div class="scroll-listado">
                    <b-list-group>
                      <b-list-group-item v-for="(plantilla, index) in filterPlantillas" :key="index"
                        class="d-flex justify-content-between align-items-center group-item-email"
                        @click="selectPlantilla(plantilla)">
                        <!-- Texto ocupa todo el espacio restante -->
                        <div class="flex-grow-1">
                          {{ plantilla.nombre }}
                        </div>

                        <!-- Botón con ícono grande pero tamaño del botón fijo -->
                        <b-button variant="primary" class="d-flex align-items-center justify-content-center" style="
                          height: 100%;
                          width: 40px;
                          min-width: 40px;
                          margin: 0;
                        " @click.stop="plantillaChloe(plantilla)" title="Usar OpenAI">
                          <i class="fa-brands fa-openai"></i>
                        </b-button>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col md="9" v-if="!waitingPlantillaChloe">
            <quill-editor v-model="contentMail" :options="editorOption" ref="quillEditor" />
            <!--Archivos Adjuntos-->
            <b-form-group label="Adjuntar PDF, JPG o PNG (Opcional):" label-for="file-input-multi" class="mt-1">
              <b-form-file id="file-input-multi" v-model="archivosAdjuntosTemp"
                placeholder="Selecciona o arrastra archivos aquí..." drop-placeholder="Suelta el archivo aquí..."
                accept=".pdf, .png, .jpg, .jpeg" multiple @input="handleFileUpload"></b-form-file>
            </b-form-group>

            <div v-if="adjuntos.length > 0" class="mb-3">
              <h6>Archivos adjuntos:</h6>
              <b-list-group>
                <b-list-group-item v-for="(file, index) in adjuntos" :key="index"
                  class="d-flex justify-content-between align-items-center list-group-item-sm p-2">

                  <span><i class="fa fa-file-pdf mr-2"></i> {{ file.name }}</span>

                  <b-button variant="danger" size="sm" @click="removeAttachment(index)" class="ml-2"
                    title="Eliminar adjunto">
                    <i class="fa fa-times"></i>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
            <!--Archivos Adjuntos-->

            <b-button variant="primary" style="margin-top: 50px !important" @click="enviarEmail">
              Enviar Email
            </b-button>
          </b-col>
          <b-col md="9" v-else class="d-flex justify-content-center align-items-center" style="height: 200px">
            <i class="fa-brands fa-openai fa-spin-custom text-primary" style="font-size: 3rem"></i>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- Modal Nuevo Email -->
    <b-modal id="modal-nuevo-email" title="Nuevo Mensaje" centered size="xl" hide-footer>
      <b-form @submit.prevent="enviarNuevoEmail">
        <b-form-group label="Para:" label-for="nuevo-email-to">
          <b-form-input id="nuevo-email-to" v-model="nuevoEmail.to" type="email" placeholder="destinatario@email.com" required />
        </b-form-group>

        <b-form-group label="Asunto:" label-for="nuevo-email-subject">
          <b-form-input id="nuevo-email-subject" v-model="nuevoEmail.subject" placeholder="Asunto del mensaje" required />
        </b-form-group>

        <b-form-group label="Mensaje:">
          <quill-editor v-model="nuevoEmail.body" :options="editorOption" style="min-height: 300px;" class="editor-nuevo-email" />
        </b-form-group>

        <b-form-group label="Adjuntar archivos (Opcional):">
          <b-form-file v-model="nuevoEmailAdjuntosTemp" placeholder="Selecciona archivos..." accept=".pdf, .png, .jpg, .jpeg" multiple @input="handleNuevoEmailFileUpload" />
        </b-form-group>

        <div v-if="nuevoEmailAdjuntos.length > 0" class="mb-3">
          <h6>Archivos adjuntos:</h6>
          <b-list-group>
            <b-list-group-item v-for="(file, index) in nuevoEmailAdjuntos" :key="index" class="d-flex justify-content-between align-items-center p-2">
              <span><i class="fa fa-file mr-2"></i> {{ file.name }}</span>
              <b-button variant="danger" size="sm" @click="removeNuevoEmailAttachment(index)">
                <i class="fa fa-times"></i>
              </b-button>
            </b-list-group-item>
          </b-list-group>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <b-button variant="outline-secondary" class="mr-2" @click="$bvModal.hide('modal-nuevo-email')">Cancelar</b-button>
          <b-button type="submit" variant="primary" :disabled="enviandoNuevoEmail">
            <span v-if="enviandoNuevoEmail"><i class="fa fa-spinner fa-spin mr-1"></i> Enviando...</span>
            <span v-else><i class="fa fa-paper-plane mr-1"></i> Enviar</span>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>


<script>
import axios from "@axios";

import {
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormCheckbox,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import BCardCode from "@core/components/b-card-code";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "EmailList",
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormCheckbox,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    VuePerfectScrollbar,
    BCardCode,
    quillEditor,
  },
  data() {
    return {
      labelColors: {
        personal: "success",
        company: "primary",
        important: "warning",
        private: "danger",
      },
      emails: [],
      searchQuery: "",
      lastSearchQuery: "",
      countSameSearch: 0,
      colors: [
        "#f87171",
        "#60a5fa",
        "#34d399",
        "#fbbf24",
        "#a78bfa",
        "#f472b6",
      ],
      showModal: false,
      selectedEmail: null,
      expandedEmailId: null,
      labels: [
        {
          id: "INBOX",
          name: "INBOX",
          type: "system",
        },
      ],
      waitingChatGpt: false,
      labelSeleccionado: "INBOX",
      readFilter: false,
      newAsk: "",
      threadMessages: [],
      loadingThread: false,
      showThread: false,
      adjuntos: [],
      archivosAdjuntosTemp: null,
      waitingNewAsk: false,
      cargandoCorreos: false,
      contentMail: ``,
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // toggled buttons
              ["blockquote", "code-block"],
              ["link", "image", "video", "formula"],

              [{ header: 1 }, { header: 2 }], // custom button values
              [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
              [{ script: "sub" }, { script: "super" }], // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ size: ["small", false, "large", "huge"] }], // custom dropdown
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              [{ font: [] }],
              [{ align: [] }],

              ["clean"],
            ],
            imageResize: true,
            handlers: {
              imageUrl: function () {
                const url = prompt("Introduce la URL de la imagen");

                if (url) {
                  const range = this.quill.getSelection(); // Obtener la selección actual

                  // Insertar la imagen con insertEmbed
                  this.quill.insertEmbed(range.index, "image", url);

                  // Obtener el último nodo insertado, que debería ser la imagen
                  const imageElement = this.quill.root.querySelector(
                    `img[src="${url}"]`
                  );

                  if (imageElement) {
                    // Aplicar el estilo directamente al nodo de la imagen
                    imageElement.style.maxWidth = "500px";
                  }
                }
              },
            },
          },
        },
      },
      plantillaSelect: {
        id: 0,
        nombre: "",
        contenido: "",
        explicacion: "",
      },
      plantillas: [],
      buscarPlantilla: "",
      waitingPlantillaChloe: false,
      interval: null,
      // Nuevo email
      nuevoEmail: {
        to: '',
        subject: '',
        body: ''
      },
      nuevoEmailAdjuntos: [],
      nuevoEmailAdjuntosTemp: null,
      enviandoNuevoEmail: false,
    };
  },
  computed: {
    filteredEmails() {
      const q = this.searchQuery.toLowerCase();
      const label = this.labelSeleccionado;
      const read = this.readFilter ? "UNREAD" : "";

      return this.emails.filter((email) => {
        const matchesQuery =
          email.body.toLowerCase().includes(q) ||
          email.from.toLowerCase().includes(q) ||
          email.subject.toLowerCase().includes(q);

        const matchesLabel = !label || email.data.labelIds.includes(label);
        const matchesRead = !read || email.data.labelIds.includes(read);

        return matchesQuery && matchesLabel && matchesRead;
      });
    },
    filterPlantillas() {
      const q = this.buscarPlantilla.toLowerCase();

      return this.plantillas.filter((pl) => {
        const matchesQuery = pl.nombre.toLowerCase().includes(q) || pl.contenido.toLowerCase().includes(q);

        return matchesQuery;
      });
    },
    formattedRespuesta() {
      if (!this.selectedEmail.chatgpt) return "";
      return this.selectedEmail?.chatgpt?.respuesta_aconsejada
        ? this.selectedEmail.chatgpt.respuesta_aconsejada.replace(/\n/g, "<br>")
        : "";
    },
  },
  methods: {
    stripHtml(html) {
      // Quita etiquetas HTML para mostrar solo texto plano
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    openEmail(email) {
      this.selectedEmail = email;

      this.contentMail = email.chatgpt.respuesta_aconsejada
        ? email.chatgpt.respuesta_aconsejada.replace(/\n/g, "<br>")
        : "";

      this.adjuntos = [];

      // Resetear estado del hilo
      this.showThread = false;
      this.threadMessages = [];
      this.loadingThread = false;


      /*if(this.selectedEmail.leido == 0){        
        axios.post("/ia/email/read", {id:this.selectedEmail.idGmail});

        this.selectedEmail.leido = 1;    
      }*/

      const plainText = this.stripHtml(email.body);
      //console.log(plainText);
    }, //11369.4 //11290
    marcarComoLeido() {
      if (this.selectedEmail.leido == 0) {
        axios.post("/ia/email/read/gmail", {
          idGmail: this.selectedEmail.idGmail,
        });

        this.selectedEmail.leido = 1;
      }
    },
    marcarComoNoLeido() {
      if (this.selectedEmail.leido == 1) {
        axios.post("/ia/email/unread/gmail", {
          idGmail: this.selectedEmail.idGmail,
        });

        this.selectedEmail.leido = 0;
      }
    },
    decodeBase64Url(base64Data) {
      if (!base64Data) return "";

      try {
        // Convierte base64 URL-safe a base64 estándar
        let base64 = base64Data.replace(/-/g, '+').replace(/_/g, '/');

        // Añadir padding si es necesario
        while (base64.length % 4) {
          base64 += '=';
        }

        // Decodificar base64 a bytes y luego a UTF-8
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return new TextDecoder('utf-8').decode(bytes);
      } catch (e) {
        console.warn("Error decodificando base64:", e);
        return "";
      }
    },
    getThreadMessageBody(payload) {
      // Buscar la parte HTML o text/plain en el payload
      let htmlPart = null;
      let textPart = null;

      const findParts = (parts) => {
        if (!parts) return;
        for (const part of parts) {
          if (part.mimeType === 'text/html' && part.body?.data) {
            htmlPart = part.body.data;
          } else if (part.mimeType === 'text/plain' && part.body?.data) {
            textPart = part.body.data;
          }
          if (part.parts) {
            findParts(part.parts);
          }
        }
      };

      // Buscar en las partes del payload
      if (payload.parts) {
        findParts(payload.parts);
      } else if (payload.body?.data) {
        // Si no hay partes, usar el body directamente
        const decoded = this.decodeBase64Url(payload.body.data);
        const esHTML = /<\/?[a-z][\s\S]*>/i.test(decoded);
        return esHTML ? decoded : "<pre>" + decoded + "</pre>";
      }

      // Preferir HTML sobre texto plano
      if (htmlPart) {
        return this.decodeBase64Url(htmlPart);
      } else if (textPart) {
        const decoded = this.decodeBase64Url(textPart);
        return "<pre>" + decoded + "</pre>";
      }

      return "<p>(Sin contenido)</p>";
    },
    async loadThread(email) {
      // Si ya está mostrando el hilo, ocultarlo
      if (this.showThread) {
        this.showThread = false;
        return;
      }

      this.loadingThread = true;
      this.showThread = true;
      this.threadMessages = [];

      try {
        const threadId = email.data.threadId;
        const response = await axios.get(`/ia/emails/thread/${threadId}`);

        // Procesar los mensajes del hilo
        this.threadMessages = response.data.map((msg) => {
          const headers = msg.payload?.headers || [];
          const subject = headers.find((h) => h.name === "Subject")?.value || "(Sin asunto)";
          const from = headers.find((h) => h.name === "From")?.value || "(Desconocido)";

          const body = this.getThreadMessageBody(msg.payload);

          return {
            id: msg.id,
            subject,
            from,
            body,
            internalDate: msg.internalDate,
          };
        });

        // Ordenar por fecha (más antiguo primero)
        this.threadMessages.sort((a, b) => Number(a.internalDate) - Number(b.internalDate));

      } catch (error) {
        console.error("Error al cargar el hilo:", error);
        this.$bvToast.toast("Error al cargar el hilo de conversación", {
          variant: "danger",
          solid: true,
        });
        this.showThread = false;
      } finally {
        this.loadingThread = false;
      }
    },
    backToList() {
      this.selectedEmail = null;
    },
    toggleEmail(id) {
      this.expandedEmailId = this.expandedEmailId === id ? null : id;
    },
    openModal(email) {
      this.selectedEmail = email;
      this.showModal = true;
    },
    getColor(from) {
      const index = from.charCodeAt(0) % this.colors.length;
      return this.colors[index];
    },
    getInitials(from) {
      const name = this.extractName(from);
      return name
        .split(" ")
        .map((w) => w[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();
    },
    extractName(from) {
      if (!from) return "(desconocido)";
      const match = from.match(/^(.*?)</);
      return match ? match[1].trim() : from;
    },
    extractMail(from) {
      if (!from) return "(desconocido)";
      const match = from.match(/<([^>]+)>/);
      return match ? match[1].trim() : from.trim();
    },
    formatDate(dateStr) {
      if (!dateStr) return "";

      // Convertir a número si viene como string de milisegundos
      const timestamp = Number(dateStr);
      const d = new Date(timestamp);

      const today = new Date();
      const isToday =
        d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear();

      if (isToday) {
        return d.toLocaleTimeString("es-ES", {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else {
        return d.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "short",
          hour: "2-digit",
          minute: "2-digit",
        });
      }
    },
    async plantillaChloe(plantilla) {
      this.waitingPlantillaChloe = true;
      const response = await axios.post("/ia/email/analizar/plantilla", {
        correo: this.selectedEmail.cuerpo,
        id: this.selectedEmail.idGmail,
        plantilla: plantilla.contenido,
        from: this.selectedEmail.from,
      });
      this.selectedEmail.chatgpt = JSON.parse(response.data.json);
      this.contentMail = this.selectedEmail.chatgpt.respuesta_aconsejada
        ? this.selectedEmail.chatgpt.respuesta_aconsejada.replace(/\n/g, "<br>")
        : "";
      this.waitingPlantillaChloe = false;
    },
    usarRespuestaChloe() {
      this.contentMail = this.selectedEmail.chatgpt.respuesta_aconsejada
        ? this.selectedEmail.chatgpt.respuesta_aconsejada.replace(/\n/g, "<br>")
        : "";
    },
    selectPlantilla(plantilla) {
      this.contentMail = plantilla.contenido;
    },
    async loadItems(autload = false) {
      if(!autload)
        axios.post("/uso", { seccion: "ia-gmail" });

      if (!autload) {
        // Carga inicial de labels
        this.labels = [
          { id: "INBOX", name: "INBOX", type: "system", cantidad: 0, total: 0 }
        ];

        this.cargandoCorreos = true;

        const responseLabels = await axios.get("/ia/emails/labels");
        this.labels.push(
          ...responseLabels.data
            .filter((data) => data.id.includes("Label"))
            .map((data) => ({ ...data, cantidad: 0, total: 0 }))
        );

        const responsePlantillas = await axios.get("/ia/emails/plantillas");
        this.plantillas = responsePlantillas.data;
      }

      // Guardar emails que vinieron de búsqueda para no perderlos
      const emailsDeBusqueda = this.emails?.filter(e => e.vieneDeBusqueda) || [];

      // Obtener emails en cache
      const responseEmails = await axios.get("/ia/emails/cache", { silencioso: autload });
      const rawEmails = responseEmails.data;

      //console.log(rawEmails);

      // Mapear emails conservando chatgpt si existía
      const emailsDelCache = rawEmails.map((email) => {
        const existingEmail = this.emails?.find((e) => e.id === email.data.id);

        const headers = email.data.payload.headers || [];
        const subject =
          headers.find((h) => h.name === "Subject")?.value || "(Sin asunto)";
        const from =
          headers.find((h) => h.name === "From")?.value || "(Desconocido)";

        const bodyData = this.getBody(email.data.payload);
        const decodedBody = bodyData
          ? Buffer.from(bodyData, "base64").toString("utf-8")
          : "";

        const attachments = this.getAttachmentsFromMessage(email.data);

        return {
          ...email,
          id: email.data.id,
          subject,
          from,
          body: decodedBody,
          attachments,
          vieneDeBusqueda: false,
          chatgpt: existingEmail ? existingEmail.chatgpt : email.chatgpt,
        };
      });

      // Filtrar emails de búsqueda que no estén ya en el cache
      const idsDelCache = new Set(emailsDelCache.map(e => e.id));
      const emailsDeBusquedaUnicos = emailsDeBusqueda.filter(e => !idsDelCache.has(e.id));

      // Combinar: primero los de búsqueda, luego los del cache
      this.emails = [...emailsDeBusquedaUnicos, ...emailsDelCache];

      // Actualizar contadores de labels
      this.labels.forEach((label) => {
        label.total = 0;
        label.cantidad = 0;
      });

      this.emails.forEach((email) => {
        if (email.data.labelIds) {
          email.data.labelIds.forEach((labelId) => {
            const label = this.labels.find((l) => l.id === labelId);
            if (label) {
              label.total += 1;
              if (email.data.labelIds.includes("UNREAD")) {
                label.cantidad += 1;
              }
            }
          });
        }
      });

      this.cargandoCorreos = false;
    }
    ,
    async loadItems2(autload = false) {
      axios.post("/uso", { seccion: "ia-gmail" });

      if (!autload) {
        this.labels = [
          {
            id: "INBOX",
            name: "INBOX",
            type: "system",
          },
        ];

        this.cargandoCorreos = true;
        const responseLabels = await axios.get("/ia/emails/labels");
        this.labels.push(
          ...responseLabels.data.filter((data) => data.id.includes("Label"))
        );
        this.labels = this.labels.map((data) => ({
          ...data,
          cantidad: 0,
          total: 0,
        }));

        const responsePlantillas = await axios.get("/ia/emails/plantillas");
        this.plantillas = responsePlantillas.data;
      }

      //console.log(responseLabels.data);

      const responseEmails = await axios.get("/ia/emails/cache");
      const rawEmails = responseEmails.data;

      this.emails = rawEmails.map((email) => {
        const headers = email.data.payload.headers || [];

        const subject =
          headers.find((h) => h.name === "Subject")?.value || "(Sin asunto)";
        const from =
          headers.find((h) => h.name === "From")?.value || "(Desconocido)";

        const bodyData = this.getBody(email.data.payload);
        const decodedBody = bodyData
          ? Buffer.from(bodyData, "base64").toString("utf-8")
          : "";

        const attachments = this.getAttachmentsFromMessage(email.data);

        return {
          ...email,
          id: email.data.id,
          subject,
          from,
          body: decodedBody,
          attachments: attachments,
          vieneDeBusqueda: false,
        };
      });

      this.emails.forEach((email) => {
        if (email.data.labelIds) {
          email.data.labelIds.forEach((labelId) => {
            const label = this.labels.find((l) => l.id === labelId);
            if (label) {
              label.total += 1; // sumamos al total
              if (email.data.labelIds.includes("UNREAD")) {
                label.cantidad += 1; // sumamos a los no leídos
              }
            }
          });
        }
      });

      this.cargandoCorreos = false;

      //console.log(this.emails);

      /*const responeGpt = await axios.get("/ia/chatgpt");
      console.log(responeGpt);*/
    },
    async askChatGpt() {
      this.waitingChatGpt = true;
      const response = await axios.post("/ia/email/analizar", {
        correo: this.selectedEmail.cuerpo,
        id: this.selectedEmail.idGmail,
        from: this.selectedEmail.from,
      });
      this.selectedEmail.chatgpt = JSON.parse(response.data.json);
      this.contentMail = this.selectedEmail.chatgpt.respuesta_aconsejada
        ? this.selectedEmail.chatgpt.respuesta_aconsejada.replace(/\n/g, "<br>")
        : "";
      this.waitingChatGpt = false;
    },
    async enviarNuevaOrden() {
      this.waitingNewAsk = true;
      const response = await axios.post("/ia/email/analizar/ajustes", {
        correo: this.selectedEmail.cuerpo,
        id: this.selectedEmail.idGmail,
        nuevoAjuste: "Por favor, ajusta la respuesta aconseja. " + this.newAsk,
      });
      this.newAsk = "";
      this.selectedEmail.chatgpt = JSON.parse(response.data.json);
      this.waitingNewAsk = false;
    },
    async marcarLeidoGmail() {
      const response = await axios.post("/ia/email/read/gmail", {
        idGmail: this.selectedEmail.idGmail,
      });
      //console.log(response);
    },
    htmlOplano(email) {
      const esHTML = /<\/?[a-z][\s\S]*>/i.test(email.cuerpo);

      if (esHTML) {
        return email.cuerpo;
      } else {
        return "<pre>" + email.cuerpo + "</pre>";
      }
    },
    getAttachmentsFromMessage(message) {
      const attachments = [];

      function findAttachments(parts) {
        for (const part of parts) {
          // Si es un attachment real
          if (part.filename && part.body && part.body.attachmentId) {
            attachments.push({
              filename: part.filename,
              attachmentId: part.body.attachmentId,
              mimeType: part.mimeType,
              size: part.body.size || 0,
              url: "",
            });
          }

          // Si tiene partes anidadas, seguimos buscando
          if (part.parts) {
            findAttachments(part.parts);
          }
        }
      }

      if (message.payload.parts) {
        findAttachments(message.payload.parts);
      }

      return attachments;
    },
    getBody(payload) {
      let body = "";
      if (payload.parts) {
        for (const part of payload.parts) {
          if (part.mimeType === "text/plain" || part.mimeType === "text/html") {
            body += part.body.data || "";
          } else if (part.parts) {
            body += this.getBody(part);
          }
        }
      } else if (payload.body && payload.body.data) {
        body += payload.body.data;
      }
      return body;
    },
    async descargarAdjunto(email, att) {
      try {
        if (!att.url) {
          const response = await axios.get(
            `/ia/email/adjuntos/${email.id}/${att.attachmentId}/${att.filename}`,
            { responseType: "arraybuffer" }
          );

          const blob = new Blob([response.data], { type: att.mimeType });
          att.url = URL.createObjectURL(blob);
        }

        // Si es imagen, abrir en nueva pestaña
        if (att.mimeType.startsWith("image/")) {
          //window.open(att.url, '_blank');
        } else {
          // Para otros archivos, descargar
          const a = document.createElement("a");
          a.href = att.url;
          a.download = att.filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      } catch (err) {
        console.error("Error al descargar adjunto:", err);
      }
    },
    openImage(att) {
      window.open(att.url, "_blank");
    },
    getLabelName(labelId) {
      const label = this.labels.find((l) => l.id === labelId);
      return label ? label.name : labelId;
    },
    getLabelColor(labelId) {
      const label = this.labels.find((l) => l.id === labelId);
      return {
        backgroundColor:
          label && label.color ? label.color.backgroundColor : "#6c757d",
        color: label && label.color ? label.color.textColor : "#fff",
      };
    },
    openModalEnviar(item) {
      this.$bvModal.show("modal-email");

      //this.contentMail = item.chatgpt.respuesta_aconsejada;

      //this.canalActual = item;
    },
    async enviarEmail() {
      let contenidoConEstilos = this.contentMail;

      // Crear un elemento temporal para manipular el HTML
      let tempDiv = document.createElement("div");
      tempDiv.innerHTML = contenidoConEstilos;

      // Buscar todas las imágenes dentro del contenido
      let images = tempDiv.querySelectorAll("img");

      // Añadir el estilo max-width a todas las imágenes
      images.forEach((img) => {
        img.style.maxWidth = this.maxWidthImg;
      });

      // Actualizar el contenido con las imágenes modificadas
      contenidoConEstilos = tempDiv.innerHTML.replaceAll(
        "<p><br></p>",
        "<p></p>"
      );

      const attachmentsPayload = await Promise.all(
          this.adjuntos.map(async (file) => ({
              data: await this.fileToBase64(file),
              name: file.name,
          }))
      );

      let info = {
        replyHtml: contenidoConEstilos,
        originalEmail: this.selectedEmail,
        adjuntos: attachmentsPayload,
      };

      axios
        .post("/ia/emails/responder", info)
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          this.$bvToast.toast("Email enviado correctamente", {
            variant: "success",
            solid: true,
          });
          this.marcarComoLeido();
          this.$bvModal.hide("modal-email");
        })
        .catch((err) => {
          this.$bvToast.toast("Error al mandar el email", {
            variant: "danger",
            solid: true,
          });
        });
    },
    // Nuevo Email
    abrirModalNuevoEmail() {
      this.nuevoEmail = { to: '', subject: '', body: '' };
      this.nuevoEmailAdjuntos = [];
      this.nuevoEmailAdjuntosTemp = null;
      this.$bvModal.show('modal-nuevo-email');
    },
    handleNuevoEmailFileUpload() {
      if (this.nuevoEmailAdjuntosTemp) {
        const files = Array.isArray(this.nuevoEmailAdjuntosTemp) ? this.nuevoEmailAdjuntosTemp : [this.nuevoEmailAdjuntosTemp];
        files.forEach(file => {
          if (!this.nuevoEmailAdjuntos.find(f => f.name === file.name)) {
            this.nuevoEmailAdjuntos.push(file);
          }
        });
        this.nuevoEmailAdjuntosTemp = null;
      }
    },
    removeNuevoEmailAttachment(index) {
      this.nuevoEmailAdjuntos.splice(index, 1);
    },
    async enviarNuevoEmail() {
      if (!this.nuevoEmail.to || !this.nuevoEmail.subject || !this.nuevoEmail.body) {
        this.$bvToast.toast("Completa todos los campos", { variant: "warning", solid: true });
        return;
      }

      this.enviandoNuevoEmail = true;

      try {
        const attachmentsPayload = await Promise.all(
          this.nuevoEmailAdjuntos.map(async (file) => ({
            data: await this.fileToBase64(file),
            name: file.name,
          }))
        );

        await axios.post("/ia/emails/nuevo", {
          to: this.nuevoEmail.to,
          subject: this.nuevoEmail.subject,
          body: this.nuevoEmail.body,
          adjuntos: attachmentsPayload,
        });

        this.$bvToast.toast("Email enviado correctamente", { variant: "success", solid: true });
        this.$bvModal.hide('modal-nuevo-email');
        this.nuevoEmail = { to: '', subject: '', body: '' };
        this.nuevoEmailAdjuntos = [];
      } catch (err) {
        console.error(err);
        this.$bvToast.toast("Error al enviar el email", { variant: "danger", solid: true });
      } finally {
        this.enviandoNuevoEmail = false;
      }
    },
    buscarGmail() {
      if (this.lastSearchQuery == this.searchQuery) {
        this.countSameSearch++;
      } else {
        this.countSameSearch = 1;
      }

      this.lastSearchQuery = this.searchQuery;

      axios
        .post("/ia/emails/buscar", {
          texto: this.searchQuery,
          cantidad: this.countSameSearch * 5,
        })
        .then((response) => response.data)
        .then((busquedaEmails) => {
          // Crear un Set con los IDs ya existentes
          const idsExistentes = new Set(this.emails.map((e) => e.id));

          const procesados = busquedaEmails
            .filter((email) => !idsExistentes.has(email.data.id)) // filtrar duplicados
            .map((email) => {
              const headers = email.data.payload.headers || [];

              const subject =
                headers.find((h) => h.name === "Subject")?.value ||
                "(Sin asunto)";
              const from =
                headers.find((h) => h.name === "From")?.value ||
                "(Desconocido)";

              const bodyData = this.getBody(email.data.payload);
              const decodedBody = bodyData
                ? Buffer.from(bodyData, "base64").toString("utf-8")
                : "";

              const attachments = this.getAttachmentsFromMessage(email.data);

              return {
                ...email,
                id: email.data.id,
                subject,
                from,
                body: decodedBody,
                attachments,
                vieneDeBusqueda: true,
              };
            });

          // Agregar solo los nuevos emails al listado existente
          this.emails = [...procesados, ...this.emails];

          // Actualizar totales por label si es necesario
          this.emails.forEach((email) => {
            if (email.labelIds) {
              email.labelIds.forEach((labelId) => {
                const label = this.labels.find((l) => l.id === labelId);
                if (label) {
                  label.total += 1;
                  if (email.labelIds.includes("UNREAD")) {
                    label.cantidad += 1;
                  }
                }
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast("Error al buscar en gmail", {
            variant: "danger",
            solid: true,
          });
        });
    },
    handleFileUpload(files) {
      if (files && files.length > 0) {
        this.adjuntos.push(...Array.from(files));
        this.archivosAdjuntosTemp = null;
      }
    },
    removeAttachment(index) {
      this.adjuntos.splice(index, 1);
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result.split(',')[1];
          resolve(base64String);
        };
        reader.onerror = error => reject(error);
      });
    }
  },
  mounted() {
    this.loadItems(); // Primera carga inmediata
    this.interval = setInterval(() => {
      this.loadItems(true);
      //console.log("autoload");
    }, 90000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-email.scss";

.group-item-email:hover {
  cursor: pointer;
}

.group-item-email:hover {
  transition: background 0.2s ease;
}

.email-body {
  white-space: pre-wrap;
  line-height: 1.6;
}

.group-item-email {
  transition: background-color 0.2s ease;
}

.email-body {
  background: #fff;
  border-radius: 6px;
  line-height: 1.6;
  white-space: pre-wrap;
}

/* Animación de entrada y salida */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.group-item-email {
  transition: background-color 0.2s ease;
}

/* 💫 Transición entre lista y detalle */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.4s ease;
}

.slide-left-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* fade suave de la lista */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}

.email-detail {
  overflow-y: auto;
  z-index: 10;
}

.email-body {
  line-height: 1.6;
  white-space: pre-wrap;
}

.group-item-email {
  transition: background-color 0.2s ease;
  cursor: pointer;
  padding: 0.75rem;
}

.active-email {
  /*background-color: #e9f0ff;*/
  border-left: 3px solid #007bff;
}

.viene-busqueda {
  border-right: 3px solid #46983b;
}

/* Transición suave del panel derecho */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.email-body {
  line-height: 1.6;
  white-space: pre-wrap;
}

.group-item-email {
  transition: background-color 0.2s ease;
  cursor: pointer;
  padding: 0.75rem;
}

.active-email {
  /*background-color: #e9f0ff;*/
  border-left: 3px solid #007bff;
}

.email-preview {
  font-size: 0.85rem;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.safe-html {
  all: revert;
  /* 🧹 Revierte todos los estilos heredados */
  background: white;
  color: #333;
  font-family: Arial, sans-serif;
  padding: 1rem;
  border-radius: 0.5rem;
}

.safe-html table {
  width: 100%;
  border-collapse: collapse;
}

.safe-html img {
  max-width: 100%;
  height: auto;
}

.safe-html * {
  max-width: 100%;
  box-sizing: border-box;
}

.email-iframe {
  width: 100%;
  height: 60vh;
  border: none;
  background: white;
}

/* Estilos para el hilo de conversación */
.thread-container {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  background-color: #fafafa;
}

.thread-header {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 10px;
}

.thread-message {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.thread-message.current-message {
  border: 2px solid #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}

.thread-message-header {
  border-bottom: 1px solid #e0e0e0;
}

.thread-message-body {
  padding: 0;
}

.thread-iframe {
  width: 100%;
  height: 200px;
  border: none;
  background: white;
}

.card-header {
  display: none !important;
}

.unread-email {
  position: relative;
  padding-left: 20px !important;
}

.unread-email::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #007bff;
  border-radius: 50%;
}

.email-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.email-sender-info {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.email-sender-name {
  display: inline;
}

.email-date-labels {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.email-date {
  font-size: 0.75rem;
  white-space: nowrap;
  color: #007bff;
  font-weight: 500;
}

.email-label-badge {
  font-size: 0.85rem;
  padding: 2px 6px;
  white-space: nowrap;
}

.face-tono {
  font-size: 18px;
}

.face-positivo {
  color: rgb(27, 113, 27);
}

.face-negativo {
  color: lightcoral;
}

.no-card-header .card-header {
  display: none;
}

.label-gmail {
  margin-right: 3px;
  margin-bottom: 3px;
}

.label-gmail:hover {
  cursor: pointer;
}

.btn-askgpt:hover {
  cursor: pointer;
}

.btn-askgpt {
  margin-bottom: 5px;
}

#openai_order_inputid:focus {
  outline: none;
  /* quita el borde de foco */
  box-shadow: none;
  /* quita el resplandor azul */
  /*border-color: #ced4da; /* mantiene el borde gris normal */
}

.groupNewAsk {
  box-shadow: none !important;
}

.badge-custom {
  padding: 2px;
  padding-right: 5px;
}

/* Animación de giro personalizada para el ícono */
@keyframes spin-openai {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.fa-spin-custom {
  display: inline-block;
  animation: spin-openai 1s linear infinite;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";

.col-plantillas {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  /* ocupa toda la altura disponible */
}

.scroll-listado {
  overflow-y: auto;
  /* scroll vertical */
  max-height: calc(100vh - 200px);
  /* ajusta según altura de header/botones */
}

.modal-max-height .modal-dialog {
  height: 100vh;
  /* altura del viewport */
  max-height: 100vh;
  margin: 0;
  /* elimina margenes verticales */
}

.modal-max-height .modal-content {
  height: 100%;
  /* ocupa toda la altura del dialog */
  max-height: 100%;
  overflow-y: auto;
  /* scroll interno si el contenido es más grande */
}

.editor-nuevo-email .ql-editor {
  min-height: 250px;
}
</style>